(function () {
  if (window.CustomCartUpsellsInit) return;
  window.CustomCartUpsellsInit = true;

  /* ================= Swiper loader ================= */
  var SWIPER_CSS_URL = "https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.css";
  var SWIPER_JS_URL = "https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.js";
  var swiperLoadingPromise = null;

  function ensureSwiperLoaded() {
    if (window.Swiper) return Promise.resolve();
    if (swiperLoadingPromise) return swiperLoadingPromise;

    swiperLoadingPromise = new Promise(function (resolve, reject) {
      if (!document.querySelector("link[data-upsells-swiper-css]")) {
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = SWIPER_CSS_URL;
        link.setAttribute("data-upsells-swiper-css", "1");
        document.head.appendChild(link);
      }

      if (document.querySelector("script[data-upsells-swiper-js]")) {
        var t = 0;
        var iv = setInterval(function () {
          t += 50;
          if (window.Swiper) {
            clearInterval(iv);
            resolve();
          }
          if (t > 8000) {
            clearInterval(iv);
            reject(new Error("Swiper load timeout"));
          }
        }, 50);
        return;
      }

      var s = document.createElement("script");
      s.src = SWIPER_JS_URL;
      s.async = true;
      s.setAttribute("data-upsells-swiper-js", "1");
      s.onload = function () { resolve(); };
      s.onerror = function () { reject(new Error("Failed to load Swiper")); };
      document.head.appendChild(s);
    });

    return swiperLoadingPromise;
  }

  /* ================= DOM helpers ================= */

  function getDrawerEl() {
    return document.querySelector(".mini-cart__inner") || document.getElementById("cart-drawer") || null;
  }

  function getUpsellsRoot() {
    var drawer = getDrawerEl();
    if (drawer) {
      var r = drawer.querySelector("[data-cart-upsells-root]");
      if (r) return r;
    }
    return document.querySelector("[data-cart-upsells-root]");
  }

  function isElementVisible(el) {
    if (!el) return false;

    var ah = el.getAttribute && el.getAttribute("aria-hidden");
    if (ah === "true") return false;

    var cs = window.getComputedStyle ? window.getComputedStyle(el) : null;
    if (cs) {
      if (cs.display === "none" || cs.visibility === "hidden" || Number(cs.opacity) === 0) return false;
    }

    var r = el.getBoundingClientRect ? el.getBoundingClientRect() : null;
    if (!r) return true;
    return r.width > 0 && r.height > 0;
  }

  function getSectionMetaFromNode(node) {
    var cur = node;
    while (cur && cur !== document.documentElement) {
      if (cur.id && cur.id.indexOf("shopify-section-") === 0) {
        return { domId: cur.id, sectionId: cur.id.replace("shopify-section-", "") };
      }
      cur = cur.parentElement;
    }
    return null;
  }

  /* ================= Swiper init/destroy ================= */

  function destroyUpsellsSwiper(root) {
    if (!root) return;
    if (root._upsellsSwiper && typeof root._upsellsSwiper.destroy === "function") {
      try { root._upsellsSwiper.destroy(true, true); } catch (e) {}
    }
    root._upsellsSwiper = null;
  }

  function initUpsellsSwiper(root) {
    if (!root || !window.Swiper) return;

    var swiperEl = root.querySelector("[data-upsells-swiper]");
    var wrapper = root.querySelector("[data-cart-upsells-list]");
    if (!swiperEl || !wrapper) return;

    var slidesCount = wrapper.querySelectorAll(".swiper-slide").length;
    if (!slidesCount) {
      destroyUpsellsSwiper(root);
      return;
    }

    destroyUpsellsSwiper(root);

    var prevEl = root.querySelector("[data-upsells-prev]");
    var nextEl = root.querySelector("[data-upsells-next]");

    root._upsellsSwiper = new window.Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 300,
      watchOverflow: true,
      grabCursor: true,
      centeredSlides: false,
      navigation: { prevEl: prevEl, nextEl: nextEl }
    });
  }

  /* ================= Money helpers ================= */

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = typeof precision === "number" ? precision : 2;
    thousands = typeof thousands === "string" ? thousands : ",";
    decimal = typeof decimal === "string" ? decimal : ".";

    if (isNaN(number) || number === null) return "0";

    var fixed = (number / 100).toFixed(precision);
    var parts = fixed.split(".");
    var dollars = parts[0];
    var cents = parts[1] ? decimal + parts[1] : "";

    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(dollars)) {
      dollars = dollars.replace(rgx, "$1" + thousands + "$2");
    }
    return dollars + cents;
  }

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, format);
    }

    if (typeof cents === "string") cents = cents.replace(".", "");
    var formatString = format || (window.Shopify && window.Shopify.money_format) || "${{amount}}";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);
    var placeholder = match ? match[1] : "amount";
    var value = "";

    switch (placeholder) {
      case "amount": value = formatWithDelimiters(cents, 2, ",", "."); break;
      case "amount_no_decimals": value = formatWithDelimiters(cents, 0, ",", "."); break;
      case "amount_with_comma_separator": value = formatWithDelimiters(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = formatWithDelimiters(cents, 0, ".", ","); break;
      case "amount_with_space_separator": value = formatWithDelimiters(cents, 2, " ", "."); break;
      case "amount_no_decimals_with_space_separator": value = formatWithDelimiters(cents, 0, " ", "."); break;
      case "amount_with_period_and_space_separator": value = formatWithDelimiters(cents, 2, " ", "."); break;
      case "amount_with_apostrophe_separator": value = formatWithDelimiters(cents, 2, "'", "."); break;
      default: value = formatWithDelimiters(cents, 2, ",", "."); break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  /* ================= Cart + recommendations ================= */

  function fetchCart() {
    return fetch("/cart.js", { credentials: "same-origin", cache: "no-store" })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .catch(function () { return { items: [] }; });
  }

  function cartSignature(cart) {
    if (!cart || !cart.items) return "";
    var ids = cart.items.map(function (i) { return i.product_id + "x" + i.quantity; }).join("|");
    return cart.item_count + "::" + ids;
  }

  function getRecommendationsUrl(productId, intent, limit) {
    var root = "/";
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) root = window.Shopify.routes.root;
    var base = root.replace(/\/?$/, "/");
    return (
      base +
      "recommendations/products.json?product_id=" + encodeURIComponent(productId) +
      "&intent=" + encodeURIComponent(intent) +
      "&limit=" + encodeURIComponent(limit * 3)
    );
  }

  function fetchRecommendationsForProduct(productId, intent, limit) {
    var url = getRecommendationsUrl(productId, intent, limit);
    return fetch(url, { credentials: "same-origin", cache: "no-store" })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .catch(function () { return { products: [] }; });
  }

  /* ================= Price sync ================= */

  function updateUpsellPriceFromSelect(selectEl) {
    if (!selectEl) return;

    var card = selectEl.closest(".cart-upsells__item");
    if (!card) return;

    var priceWrap = card.querySelector(".cart-upsells__price");
    if (!priceWrap) return;

    var root = card.closest("[data-cart-upsells-root]");
    var moneyFormat =
      (root && root.getAttribute("data-upsells-money-format")) ||
      (window.Shopify && window.Shopify.money_format) ||
      "${{amount}}";

    var opt = selectEl.options[selectEl.selectedIndex];
    if (!opt) return;

    var price = parseInt(opt.getAttribute("data-price") || "0", 10);
    var compareAt = parseInt(opt.getAttribute("data-compare-at") || "0", 10);

    var html = "";
    if (compareAt && compareAt > price) {
      html =
        '<span class="cart-upsells__price-old">' + formatMoney(compareAt, moneyFormat) + "</span>" +
        '<span class="cart-upsells__price-new">' + formatMoney(price, moneyFormat) + "</span>";
    } else {
      html = '<span class="cart-upsells__price-regular">' + formatMoney(price, moneyFormat) + "</span>";
    }

    priceWrap.innerHTML = html;
  }

  /* ================= Build cards ================= */

  function buildCardsHtml(products, inCartProductIds, moneyFormat, limit) {
    var usedIds = new Set();
    var picked = [];

    products.forEach(function (p) {
      if (!p || p.available === false) return;
      if (inCartProductIds.indexOf(p.id) !== -1) return;
      if (usedIds.has(p.id)) return;
      if (picked.length >= limit) return;

      usedIds.add(p.id);
      picked.push(p);
    });

    if (!picked.length) return "";

    return picked.map(function (p) {
      var img = p.featured_image || (p.images && p.images[0]);
      var imgUrl = null;
      if (img && typeof img === "string") imgUrl = img.replace(/_(\d+x\d+|x\d+)\./, "_160x.");
      else if (img && img.src) imgUrl = img.src;

      var title = p.title || "";
      var words = title.split(" ").filter(function (w) { return w.length; });
      var shortTitle = words.slice(0, 5).join(" ");
      if (words.length > 5) shortTitle += "…";

      var variants = p.variants || [];
      var fav = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i] && variants[i].available) { fav = variants[i]; break; }
      }
      if (!fav && variants.length) fav = variants[0] || null;

      var selectedVariant = fav || null;
      var basePrice = selectedVariant && selectedVariant.price != null ? selectedVariant.price : p.price;
      var baseCompareAt = selectedVariant && selectedVariant.compare_at_price != null
        ? selectedVariant.compare_at_price
        : p.compare_at_price;

      var priceHtml = "";
      if (baseCompareAt && baseCompareAt > basePrice) {
        priceHtml =
          '<span class="cart-upsells__price-old">' + formatMoney(baseCompareAt, moneyFormat) + "</span>" +
          '<span class="cart-upsells__price-new">' + formatMoney(basePrice, moneyFormat) + "</span>";
      } else {
        priceHtml = '<span class="cart-upsells__price-regular">' + formatMoney(basePrice, moneyFormat) + "</span>";
      }

      var hasMultipleVariants = variants.length > 1;
      var selectedVariantId = selectedVariant && selectedVariant.id;
      var handle = p.handle || "";
      var productUrl = p.url || (handle ? "/products/" + handle : "#");

      var selectorHtml = "";
      if (hasMultipleVariants) {
        selectorHtml += '<div class="cart-upsells__variant-row">';
        selectorHtml += '<select class="cart-upsells__variant-select" data-upsell-variant-select>';
        variants.forEach(function (v) {
          if (!v) return;
          var optLabel = v.public_title || v.title || "";
          selectorHtml +=
            '<option value="' + v.id + '"' +
              (selectedVariantId && String(v.id) === String(selectedVariantId) ? " selected" : "") +
              ' data-price="' + (v.price || 0) + '"' +
              ' data-compare-at="' + (v.compare_at_price || 0) + '">' +
              optLabel +
            "</option>";
        });
        selectorHtml += "</select></div>";
      }

      var buttonHtml = "";
      if (!hasMultipleVariants && selectedVariant && selectedVariant.id) {
        buttonHtml =
          '<button type="button" class="cart-upsells__add" data-cart-upsell-add data-variant-id="' + selectedVariant.id + '">' +
            '<span class="cart-upsells__add-icon">+</span>' +
          "</button>";
      } else {
        buttonHtml =
          '<button type="button" class="cart-upsells__add" data-cart-upsell-add>' +
            '<span class="cart-upsells__add-icon">+</span>' +
          "</button>";
      }

      var cardHtml =
        '<div class="cart-upsells__item">' +
          '<div class="cart-upsells__row">' +
            '<a href="' + productUrl + '" class="cart-upsells__media" data-instant>' +
              (imgUrl ? '<img src="' + imgUrl + '" alt="' + shortTitle.replace(/"/g, "&quot;") + '">' : "") +
            "</a>" +
            '<div class="cart-upsells__content">' +
              '<a href="' + productUrl + '" class="cart-upsells__title" data-instant>' + shortTitle + "</a>" +
              '<div class="cart-upsells__price">' + priceHtml + "</div>" +
            "</div>" +
            buttonHtml +
          "</div>" +
          (selectorHtml || "") +
        "</div>";

      return '<div class="swiper-slide">' + cardHtml + "</div>";
    }).join("");
  }

  /* ================= Render controller ================= */

  var lastSignature = null;
  var updating = false;
  var pendingRender = false;
  var rafQueued = false;

  // подавляем observer, когда сами меняем DOM
  var suppressObservers = false;
  var suppressTimer = null;

  function suppressFor(ms) {
    suppressObservers = true;
    clearTimeout(suppressTimer);
    suppressTimer = setTimeout(function () {
      suppressObservers = false;
    }, ms || 200);
  }

  function scheduleRender(force) {
    if (rafQueued) return;
    rafQueued = true;

    requestAnimationFrame(function () {
      rafQueued = false;
      doRender(!!force);
    });
  }

  function doRender(force) {
    var drawer = getDrawerEl();
    var root = getUpsellsRoot();
    if (!root) return;

    if (!force) {
      if (!isElementVisible(drawer) && !isElementVisible(root)) return;
    }

    if (updating) {
      pendingRender = true;
      return;
    }

    renderCartUpsells(force);
  }

  function renderCartUpsells(force) {
    var root = getUpsellsRoot();
    if (!root) return;

    var listEl = root.querySelector("[data-cart-upsells-list]");
    if (!listEl) return;

    updating = true;

    var intent = root.getAttribute("data-upsells-intent") || "complementary";
    var limit = parseInt(root.getAttribute("data-upsells-limit") || "3", 10);
    var moneyFormat =
      root.getAttribute("data-upsells-money-format") ||
      (window.Shopify && window.Shopify.money_format) ||
      "${{amount}}";

    fetchCart().then(function (cart) {
      var sig = cartSignature(cart);

      // ✅ ВАЖНО: даже при force НЕ перерисовываем, если уже есть слайды и сиг не менялся
      if (sig === lastSignature && listEl.querySelector(".swiper-slide")) {
        updating = false;
        if (pendingRender) { pendingRender = false; scheduleRender(false); }
        return;
      }

      lastSignature = sig;

      if (!cart || !cart.items || !cart.items.length) {
        suppressFor(150);
        root.style.display = "none";
        listEl.innerHTML = "";
        destroyUpsellsSwiper(root);

        updating = false;
        if (pendingRender) { pendingRender = false; scheduleRender(false); }
        return;
      }

      var inCartProductIds = cart.items.map(function (i) { return i.product_id; });
      var allRecs = [];
      var productIds = inCartProductIds.slice();
      var idx = 0;

      function finish() {
        var html = buildCardsHtml(allRecs, inCartProductIds, moneyFormat, limit);

        suppressFor(200);

        if (!html) {
          root.style.display = "none";
          listEl.innerHTML = "";
          destroyUpsellsSwiper(root);

          updating = false;
          if (pendingRender) { pendingRender = false; scheduleRender(false); }
          return;
        }

        root.style.display = "";
        listEl.innerHTML = html;

        var selects = listEl.querySelectorAll("[data-upsell-variant-select]");
        selects.forEach(function (sel) { updateUpsellPriceFromSelect(sel); });

        ensureSwiperLoaded()
          .then(function () { initUpsellsSwiper(root); })
          .catch(function () {});

        updating = false;
        if (pendingRender) { pendingRender = false; scheduleRender(false); }
      }

      function step() {
        if (idx >= productIds.length || allRecs.length >= limit * 3) {
          finish();
          return;
        }

        var pid = productIds[idx++];
        fetchRecommendationsForProduct(pid, intent, limit).then(function (data) {
          if (data && Array.isArray(data.products)) allRecs = allRecs.concat(data.products);
          step();
        }).catch(function () { step(); });
      }

      step();
    }).catch(function () {
      updating = false;
      if (pendingRender) { pendingRender = false; scheduleRender(false); }
    });
  }

  /* ================= Refresh mini-cart after upsell add ================= */

  function refreshMiniCartFromSection(detail) {
    var drawer = getDrawerEl();
    if (!drawer) {
      scheduleRender(true);
      return Promise.resolve();
    }

    var meta = getSectionMetaFromNode(drawer) || getSectionMetaFromNode(drawer.parentElement);
    if (!meta || !meta.sectionId) {
      scheduleRender(true);
      return Promise.resolve();
    }

    return fetch("/?sections=" + encodeURIComponent(meta.sectionId), {
      credentials: "same-origin",
      cache: "no-store"
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) {
        if (!json || !json[meta.sectionId]) {
          scheduleRender(true);
          return;
        }

        var html = json[meta.sectionId];
        var tmp = document.createElement("div");
        tmp.innerHTML = html;

        var freshSection = tmp.querySelector("#" + meta.domId) || tmp.firstElementChild;
        if (!freshSection) {
          scheduleRender(true);
          return;
        }

        var freshDrawer =
          freshSection.querySelector(".mini-cart__inner") ||
          freshSection.querySelector("#cart-drawer");

        var liveDrawer = getDrawerEl();
        if (!freshDrawer || !liveDrawer) {
          scheduleRender(true);
          return;
        }

        var liveList = liveDrawer.querySelector(".mini-cart__line-item-list");
        var freshList = freshDrawer.querySelector(".mini-cart__line-item-list");

        suppressFor(250);

        if (liveList && freshList) {
          liveList.innerHTML = freshList.innerHTML;
        } else {
          liveDrawer.innerHTML = freshDrawer.innerHTML;
        }

        // cart changed -> rerender upsells (new signature)
        lastSignature = null;
        scheduleRender(true);
      })
      .catch(function () {
        scheduleRender(true);
      });
  }

  /* ================= Observers ================= */

  function setupDrawerObserver() {
    var drawer = getDrawerEl();
    if (!drawer) return;

    if (window.CustomCartUpsellsDrawerObserver) {
      window.CustomCartUpsellsDrawerObserver.disconnect();
    }

    var obs = new MutationObserver(function (muts) {
      if (suppressObservers) return;

      var root = getUpsellsRoot();
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (root && t && root.contains(t)) {
          // ignore Swiper/upsells internal changes
          return;
        }
      }

      scheduleRender(false);
    });

    obs.observe(drawer, { childList: true, subtree: true });
    window.CustomCartUpsellsDrawerObserver = obs;
  }

  function setupInsertionObserver() {
    if (window.CustomCartUpsellsInsertionObserver) return;

    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        var nodes = m.addedNodes || [];
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (!n || n.nodeType !== 1) continue;

          if (
            (n.matches && (n.matches(".mini-cart__inner") || n.matches("[data-cart-upsells-root]"))) ||
            (n.querySelector && (n.querySelector(".mini-cart__inner") || n.querySelector("[data-cart-upsells-root]")))
          ) {
            setupDrawerObserver();
            scheduleRender(true);
            return;
          }
        }
      }
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });
    window.CustomCartUpsellsInsertionObserver = obs;
  }

  /* ================= Open check (FIXED) ================= */

  var openCheckTimer = null;

  function scheduleOpenCheck() {
    clearTimeout(openCheckTimer);
    openCheckTimer = setTimeout(function () {
      var drawer = getDrawerEl();
      var root = getUpsellsRoot();
      if (!drawer || !root) return;
      if (!isElementVisible(drawer)) return;

      var listEl = root.querySelector("[data-cart-upsells-list]");
      var hasSlides = listEl && listEl.querySelector(".swiper-slide");

      // ✅ Рендерим ТОЛЬКО если пусто
      if (!hasSlides) {
        lastSignature = null;
        scheduleRender(true);
      }
    }, 90);
  }

  // ✅ ВАЖНО: клики внутри миникарта НЕ запускают open-check (иначе стрелки/свайп ломают карусель)
  document.addEventListener("click", function (e) {
    if (e.target.closest(".mini-cart__inner") || e.target.closest("#cart-drawer")) return;
    scheduleOpenCheck();
  });

  /* ================= Events ================= */

  document.addEventListener("change", function (event) {
    var select = event.target.closest("[data-upsell-variant-select]");
    if (!select) return;
    updateUpsellPriceFromSelect(select);
  });

  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-cart-upsell-add]");
    if (!button) return;

    var variantId = button.getAttribute("data-variant-id");

    if (!variantId) {
      var card = button.closest(".cart-upsells__item");
      if (card) {
        var select = card.querySelector("[data-upsell-variant-select]");
        if (select) variantId = select.value;
      }
    }

    if (!variantId) return;

    event.preventDefault();
    button.disabled = true;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      credentials: "same-origin"
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        button.disabled = false;
        return refreshMiniCartFromSection(data);
      })
      .catch(function () {
        button.disabled = false;
      });
  });

  ["cart:updated", "cart:refresh", "cart:change", "ajaxProduct:added", "product:added", "cart-drawer:open"].forEach(
    function (evt) {
      document.addEventListener(evt, function () {
        lastSignature = null;
        scheduleRender(true);
      });
    }
  );

  /* ================= Start ================= */

  setupInsertionObserver();
  setupDrawerObserver();
  scheduleRender(true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      setupInsertionObserver();
      setupDrawerObserver();
      scheduleRender(true);
    });
  }
})();
